<script setup>

import { useRoute,useRouter } from 'vue-router';
import { RouterView } from 'vue-router'
import { ref,onMounted } from 'vue';
import { qtWebChannel} from './main'
import { setTheme,  setLanguage} from './main'

const isLoggedIn = ref(false);
const user = ref(null);
const route = useRoute();
const router = useRouter();

const checkActiveElementFocus = ()=>
{
  var activeElement = document.activeElement;
  if("messageInputId" == activeElement.id ||
  "currentTitleInputId" == activeElement.id ||
  "sessionInputId" == activeElement.id
  )
  {
    //qtWebChannel.OnInputStatusChanged(true);
  }
}

const checkActiveElementBlur = ()=>
{
  //qtWebChannel.OnInputStatusChanged(false);
}



onMounted(async  () => {
  //setTheme('dark');
  setTheme('light');
  setLanguage('zh-CN');
  document.addEventListener('focus', checkActiveElementFocus, true);
  document.addEventListener('blur', checkActiveElementBlur, true);
});

const postMessage =(string)=>{
  console.log(string);
 //qtWebChannel.HandleCmd(string);
}

</script>

<template>
  <router-view v-slot="{ Component }" @postToCAD="postMessage">
      <component :is="Component" />
  </router-view>
  
  <!-- <div id="app">
    <router-view v-if="isLoggedIn" v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
    <div v-else>
      <p>Loading...</p>
    </div>
  </div> -->

</template>
